

import { numberTemplate as apiNumberTemplate } from '@/apis'
export default {
  namespaced:true,
  state : {
    templateNumberType: [],
  },
  
  getters : {
    GETTERS_TEMPLATENUMBER_TYPE: (state) => state.templateNumberType,
  },
  
  mutations : {
    MUTATION_TEMPLATENUMBER_TYPE (state, data) {
      state.templateNumberType = data
    },
  },
  
  actions : {
    async ACTION_TEMPLATENUMBER_TYPE ({ state, commit }) {
      //check for lazy load
      if (state.templateNumberType.length !== 0) return
      const [err,data] = await apiNumberTemplate.getNumberType()

      if(err){  
        return
      }
 
      commit('MUTATION_TEMPLATENUMBER_TYPE', data)
    },
  }
} 